<template>
  <button
    v-if="mounted"
    :aria-label="model ? label : 'Verwijder uit favorieten'"
    class="btn-clear group flex focus:outline-hidden"
    @click="toggleFavorite()"
  >
    <HeartIcon
      v-if="model"
      class="h-6 w-6 group-hover:scale-125 group-focus:scale-125"
    />
    <OutlinedHeartIcon
      v-else
      class="h-6 w-6 group-hover:scale-125 group-focus:scale-125"
    />

    <span v-if="!onlyIcon" class="ml-2">{{ label }}</span>
  </button>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { HeartIcon as OutlinedHeartIcon } from '@heroicons/vue/24/outline'
import { HeartIcon } from '@heroicons/vue/24/solid'

const model = defineModel({
  type: Boolean,
  default: false,
})

defineProps({
  onlyIcon: {
    type: Boolean,
    default: true,
  },
  label: {
    type: String,
    default: 'Toevoegen aan favorieten',
  },
})

const mounted = ref(false)
onMounted(() => {
  mounted.value = true
})

function toggleFavorite() {
  model.value = !model.value
}
</script>
